import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

import { invoiceQuerySchema } from './invoice-query-schema';

export const invoiceFormSchema = invoiceQuerySchema
  .omit({
    client_id: true,
    brand_id: true,
    partner_id: true,
  })
  .extend({
    invoice_date: z.string().min(1, 'Invoice Date is required'),
    notes: z.string(),
    invoice_amount: currencyInput.formSchema(),
  })
  .refine(
    ({ client }) => {
      if (!client) {
        return false;
      }
      return true;
    },
    { message: 'Company is required', path: ['client'] }
  );

export type InvoiceFormSchema = z.infer<typeof invoiceFormSchema>;
